import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, catchError, throwError } from 'rxjs';
import { APP_CONFIG, AppConfig } from 'src/environments/app-environment.models';
import { MaintenanceModeService } from './maintenance-mode.service';

export const maintenanceModeInterceptor: HttpInterceptorFn = (request, next) => {
  const appConfig = inject<AppConfig>(APP_CONFIG);
  const maintenanceMode = inject(MaintenanceModeService);
  const publicApiBaseUrl = appConfig.publicApiBaseUrl.replace(/\/+$/, '');
  const isPublicApiRequest = request.url.startsWith(publicApiBaseUrl + '/');
  const requestContext = maintenanceMode.requestContext;
  if (!isPublicApiRequest || requestContext === null) return next(request);
  if (maintenanceMode.isActive) return EMPTY;

  return next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 503 && maintenanceMode.requestContext === requestContext) {
        maintenanceMode.show();
        return EMPTY;
      }
      return throwError(() => error);
    }),
  );
};
